import React, { useState, useEffect, useContext } from 'react'
import Box from '@zuto/core/src/box'
import { GridItem } from '@zuto/core/src/grid'
import styled from 'styled-components'
import { Grid, styled as MuiStyled } from '@mui/material'
import { VehicleDetailsDataObject } from '../../../services/vehicle-service'
import VehicleCard from './VehicleCard'
import { scrollToTheTop } from '../../Questions/utils'
import { ApplicationFormContext } from '../../ApplicationForm/ApplicationFormContext'
import withFade from '../../HOC/withFade'
import TrustBox from '../../TrustPilotHeader/TrustBox'

const MediaQueryH2 = styled(Box)`
  @media (max-width: 435px) {
    font-size: 24px;
    line-height: 32px;
  }
  margin-bottom: 10px
`

const StyledImg = styled.img<{ isClassifiedSource?: boolean }>`
  border-radius: 12px;
  width: 100%;
  max-height: 250px;
  background: #333;
  margin-bottom: -40px;
  ${(props) => (props.isClassifiedSource ? 'object-fit: cover;' : 'object-fit: contain;')};
  @media (max-width: 370px) {
    max-height: 184px;
  }
`

const MediaQueryGrid = styled(GridItem)`

iframe{
  position: initial!important;
  width: 98%!important;
}

h3{
  text-align: center;
  margin-top: 23px
}

.trustPilotLogo {
  margin-bottom: 6px;
  display: block;
  margin: auto;
}

.trustpilot-widget{
  margin-top: 6px
}

@media (max-width: 370px) {
  button {
    font-size: 14px;
    span {
      margin: auto;
    }
  }

  button[data-testid="start-application-button-centered"] {
    span {
      font-size: 18px;
      margin: 0 16px;
    }
  }

  h3{
    font-size: 18px;
  }
}
  margin-top: 9px
`

const ImageWrapper = MuiStyled('div')({
  minHeight: '234px',
  '@media (max-width: 370px)': {
    minHeight: '168px'
  }
})

interface VehicleIntroductionProps {
  vehicle: VehicleDetailsDataObject | undefined,
  isClassifiedSource: boolean,
  sourceDisplayName?: string
}

const VehicleIntroLargerImageNoDropdown = ({
  vehicle, isClassifiedSource, sourceDisplayName
}: VehicleIntroductionProps) => {
  const [imageLoaded, setImageLoaded] = useState(true)
  const appFormContext = useContext(ApplicationFormContext)
  const { featureSwitches } = appFormContext
  const { isTrustpilotV1 } = featureSwitches ?? {}

  useEffect(scrollToTheTop, [])

  const isVehicleImage = (imageLoaded && vehicle?.imageUrls?.length ? vehicle?.imageUrls?.length > 0 : false)
  const vehicleSourceResized = vehicle?.imageUrls?.[0] ? vehicle?.imageUrls?.[0].replace('/w300/', '/w480h360/') : ''

  return (
    <>
      <MediaQueryGrid gridColumn={['auto / span 12', '3 / span 8']}>
        <MediaQueryH2 as="h2" textStyle="material.display.regular.large" mb={2} mt={1}>
          It should only take a couple of minutes, let&apos;s get started
        </MediaQueryH2>
        {vehicle?.imageUrls?.length && imageLoaded
          ? (
            <ImageWrapper>
              <StyledImg
                isClassifiedSource={isClassifiedSource}
                data-testid="vehicle-image"
                onError={() => { setImageLoaded(false) }}
                alt="selected vehicle"
                src={vehicleSourceResized}
                id="tag_main-vehicle-image"
              />
            </ImageWrapper>
          ) : <></>}
        <VehicleCard
          vehicle={vehicle}
          vehicleImg={isVehicleImage}
          isClassifiedSource={isClassifiedSource}
          sourceDisplayName={sourceDisplayName}
        />
        {!isTrustpilotV1 && <div data-testid="at-footer-tp-widget">
          <Box as="h3" textStyle="material.body.large.bold" mb={1} mt={2}>
            Customers love Zuto&apos;s service
          </Box>
          <Grid mt={4} mb={4} style={{ textAlign: 'center' }}>
            <TrustBox  />
          </Grid>
        </div>}
      </MediaQueryGrid>
    </>
  )
}

export default withFade(VehicleIntroLargerImageNoDropdown)
